import validationRules, {
  ValidationRule,
  ValidationRulesInterface,
} from "./driver.validation";

export const validationMessage = (
  fieldName: keyof ValidationRulesInterface
) => {
  const rules = validationRules[fieldName] as ValidationRule;
  if (!rules) return ""; // If no rules defined, return empty string
  return rules.message; // Access message based on locale
};

export const isFieldRequired = (fieldName: keyof ValidationRulesInterface) => {
  const rules = validationRules[fieldName] as ValidationRule;
  if (!rules) return false; // If no rules defined, consider it valid
  return rules?.required ?? false;
};

export const isFieldValid = (
  fieldName: keyof ValidationRulesInterface,
  user: Record<string, any>
) => {
  const fieldValue = user[fieldName];
  const rules = validationRules[fieldName] as ValidationRule;
  if (!rules) return true; // If no rules defined, consider it valid
  if (fieldValue && fieldValue.length > 0) {
    let maxLength = rules.maxLength ?? 0;
    let minLength = rules.minLength ?? 0;
    if (!rules.maxLength) {
      maxLength = 256;
    }
    if (!rules.minLength) {
      minLength = 0;
    }
    const correctLength =
      fieldValue.length <= maxLength && fieldValue.length >= minLength;
    if (!correctLength) {
      return false;
    }
    if (fieldName == "password_confirmation") {
      return user.password === user.password_confirmation;
    }
    return rules?.regex?.test(fieldValue);
  } else {
    if (rules.required) {
      return false;
    }
    return true;
  }
};
